import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Text } from 'react-native';
import Table from './components/Table';
import { paginatedIndexes, pageCount } from './functions/pagination';
import { valueFor } from './functions/util';
import { useDefaults } from './Context';
import LengthMenu from './components/LengthMenu';
import Row from './components/Row';
var filteredBySearch = function filteredBySearch(entries, columns, term) {
  if (!term) {
    return entries;
  }
  term = term.toLowerCase();
  return entries.filter(function (entry) {
    return columns.filter(function (_ref) {
      var key = _ref.key,
        search = _ref.search;
      if (search !== false) {
        var value = valueFor(entry, key, columns);
        if (value && value.toString().toLowerCase().includes(term)) {
          return true;
        }
      }
      return false;
    }).length;
  });
};
var paginated = function paginated(entries, page, pageLength) {
  var _paginatedIndexes = paginatedIndexes(entries.length, page, pageLength),
    _paginatedIndexes2 = _slicedToArray(_paginatedIndexes, 2),
    startIndex = _paginatedIndexes2[0],
    endIndex = _paginatedIndexes2[1];
  return entries && entries.slice(startIndex, endIndex);
};
var sorted = function sorted(_ref2) {
  var entries = _ref2.entries,
    order = _ref2.order,
    columns = _ref2.columns;
  return _toConsumableArray(entries).sort(function (entry, other) {
    var entryResult = 0;
    order.some(function (_ref3) {
      var key = _ref3.key,
        direction = _ref3.direction;
      var entryValue = valueFor(entry, key, columns);
      var otherValue = valueFor(other, key, columns);
      if ('string' === typeof entryValue) {
        entryValue = entryValue.toLowerCase();
      }
      if ('string' === typeof otherValue) {
        otherValue = otherValue.toLowerCase();
      }
      if (entryValue === otherValue) {
        return false;
      } else {
        var result = entryValue < otherValue ? -1 : 1;
        if (typeof entryValue === 'undefined' || entryValue === null) {
          result = -1;
        } else if (typeof otherValue === 'undefined' || otherValue === null) {
          result = 1;
        }
        entryResult = 'asc' === direction ? result : result * -1;
        return true;
      }
    });
    return entryResult;
  });
};
export var Simple = function Simple(props) {
  var _useDefaults = useDefaults(props),
    data = _useDefaults.data,
    columns = _useDefaults.columns,
    lengthMenu = _useDefaults.lengthMenu,
    paginationLinks = _useDefaults.paginationLinks,
    setSettings = _useDefaults.setSettings,
    movableColumns = _useDefaults.movableColumns,
    styles = _useDefaults.styles,
    component = _useDefaults.component,
    buttons = _useDefaults.buttons,
    htmlTable = _useDefaults.htmlTable,
    disableSearch = _useDefaults.disableSearch,
    alwaysSort = _useDefaults.alwaysSort,
    multiSort = _useDefaults.multiSort,
    refetch = _useDefaults.refetch,
    copyComponent = _useDefaults.copyComponent,
    initialPageLength = _useDefaults.pageLength;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    loadedData = _useState2[0],
    setLoadedData = _useState2[1];
  var _useState3 = useState({
      filtered: [],
      visible: []
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    entries = _useState4[0],
    setEntries = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    order = _useState6[0],
    setOrder = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    page = _useState8[0],
    setPage = _useState8[1];
  var _useState9 = useState('All' === initialPageLength ? 0 : initialPageLength || 10),
    _useState10 = _slicedToArray(_useState9, 2),
    pageLength = _useState10[0],
    setPageLength = _useState10[1];
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    searchTerm = _useState12[0],
    setSearchTerm = _useState12[1];
  if (!data) return /*#__PURE__*/React.createElement(Text, null, "Loading...");
  var updateEntries = function updateEntries(options) {
    var newOrder = options.newOrder,
      newPage = options.newPage,
      newPageLength = options.newPageLength,
      newSearchTerm = options.newSearchTerm;
    var search = typeof newSearchTerm !== 'undefined' ? newSearchTerm : searchTerm;
    var filtered = filteredBySearch(data, columns, search);
    var maxPage = pageCount(filtered.length, newPageLength || pageLength) - 1;
    if (maxPage < (newPage || page)) {
      newPage = maxPage;
    }
    var visible = paginated(sorted({
      columns: columns,
      entries: filtered,
      order: newOrder || order
    }), newPage === undefined ? page : newPage, newPageLength === undefined ? pageLength : newPageLength);
    setEntries({
      filtered: filtered,
      visible: visible
    });
    if (data != loadedData) {
      setLoadedData(data);
    }
    if (typeof newOrder !== 'undefined') {
      setOrder(newOrder);
    }
    if (typeof newPage !== 'undefined') {
      setPage(newPage);
    }
    if (typeof newPageLength !== 'undefined') {
      setPageLength(newPageLength);
    }
    if (typeof newSearchTerm !== 'undefined') {
      setSearchTerm(newSearchTerm);
    }
    if (setSettings) {
      setSettings({
        search: search,
        order: newOrder || order
      });
    }
  };
  if (!order) {
    var newOrder = [];
    columns.forEach(function (column) {
      if ('asc' === column.sort) {
        newOrder.push({
          key: column.key,
          direction: 'asc'
        });
      } else if ('desc' === column.sort) {
        newOrder.push({
          key: column.key,
          direction: 'desc'
        });
      }
    });
    setOrder(newOrder);
  }
  if (data && order && data != loadedData) {
    updateEntries({});
  }
  return /*#__PURE__*/React.createElement(Table, {
    entries: entries.visible,
    columns: columns,
    order: order,
    updateEntries: updateEntries,
    page: page,
    count: entries.filtered.length,
    lengthMenu: lengthMenu,
    pageLength: pageLength,
    paginationLinks: paginationLinks,
    searchTerm: searchTerm,
    movableColumns: movableColumns,
    styles: styles,
    component: component,
    htmlTable: htmlTable,
    disableSearch: disableSearch,
    alwaysSort: alwaysSort,
    multiSort: multiSort,
    buttons: buttons,
    refetch: refetch,
    copyComponent: copyComponent
  });
};
export default Simple;